import { ReactComponent as CopySvg } from "../../assets/icons/copy-white.svg";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import Modal from "../utils/Modal/Modal";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  Row,
  Label,
} from "./CollectionSettingsModal.styles";

const CollectionSettingsModal = ({ isOpen, onClose, onCopy, customPrompt }) => {
  useLockBodyScroll(isOpen);

  const handleCopy = () => {
    onCopy();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>Prompt</ModalTitle>
            <CloseButton onClick={handleCopy}>
              <CopySvg width={20} height={20} />
            </CloseButton>
          </Row>

          <Label>{customPrompt}</Label>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default CollectionSettingsModal;
